
const appStyle = (theme,) => ({
  mainPanel: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    overflow: "auto",
    position: "relative",
    float: "right",
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    backgroundColor: "white",
  },
  header: {
    width: "100%",
    padding: '10px 0 0px 0px',
    textAlign: 'left',
    color: '#fff',
    backgroundImage: `url("https://shopdisneyeu.scene7.com/is/image/DisneyStoreES/34819_marvel_mania_tb?$tb$")`,
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'cover',
    backgroundSize: '100% 100%',
    height: '591px',
  },
  headerApp: {
    width: "100%",
    margin: '0px 0 20px 0px',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'cover',
    backgroundSize: '100% 100%',
    height: '552px',
  },
  headerContent: {
    margin: "40px 0 0 20px",
    width: '600px',
  },
  headerTitle: {
    fontFamily: 'Poppins',
    fontSize: '30px',
    fontWeight: 'bold',
    width: "90%",
    background: `rgba(0, 0, 0, 0.5)`,
    padding: "10px 10px 0 10px",
  },
  headerSecondTitle: {
    color: '#F20746',
    lineHeight: '50px',
  },
  menu: {
    width: "100%",
    padding: 15,
    backgroundColor: "#F8F9FA",
  },

  chip: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontSize: '11px',
    margin: "0 5px 0 5px",
    borderColor: `rgb(255,152,109)`,
    color: 'black',
    "&:hover": {
      borderBottom: `5px solid #EDCB06`,
    },
  },
  chipLogo: {
    height: '51px',
    width: '149px',
    textAlign: 'center',
  },
  textSearch: {
    padding: "0 30px 0px 0px",
    fontFamily: 'Poppins',
    fontSize: '15px',
  },
  mainPanelContent: {
    width: "95%",
    margin: "10px 0px 0px 10px",
  },
  cardIcon: {
    width: 30,
  },
  cardRootPublicity: {
    backgroundColor: '#F2F2F2',
    maxWidth: 368,
    width: 368,
    maxHeight: 200,
    margin: "5px 5px 10px 5px",
    cursor: 'pointer',
    "&:hover": {
      boxShadow: `0 0 20px #000000`,
    },
  },

  cardRoot: {
    border: "1px solid white",
    width: "98%",
    maxWidth: 330,
    minHeight: 350,
    height: 350,
    margin: "10px 0 10px 10px",
    cursor: 'pointer',
    "&:hover": {
      boxShadow: `0 0 20px #000000`,
    },
  },
  cardMedia: {
    height: "100%",
    width: "100%"
  },
  cardContent: {
    paddingBottom: 3,
    height: "100%"
  },

  cardTitle: {
    fontFamily: 'Poppins',
    fontWeight: "bold",
    color: '#F20746',
    fontSize: 13,
    margin: '0px 0 3px 0',
  },
  cardTitleDate: {
    fontFamily: 'Poppins',
    fontWeight: "bold",
    color: '#F20746',
    fontSize: 13,
    padding: '4px 0 3px 0',
  },

  cardSubTitle: {
    color: 'black',
  },
  cardText: {
    height: 70,
    fontFamily: 'Poppins',
    color: 'black',
    fontWeight: "bold",
    textAling: 'justify',
    marginBottom: 5
  },
  divider: {
    width: "100%",
    height: "10px",
    backgroundColor: 'red',
  },
  footer: {
    marginTop: "50px",
    paddingTop: '20px',
    background: 'linear-gradient(90deg, #F20746 0%, #D91448 100%)',
    textAlign: 'center',
    color: 'white',
    width: "100%"
  },
  SocialIcons: {
    margin: '20px 20px 30px 0',
    color: 'white',
    width: 15
  },
  copyright: {
    fontFamily: 'Poppins',
    fontSize: '13px',
    marginTop: 20,
    marginBottom: 20,
  },
  footerContentText: {
    marginTop: 30,
  },
  footerText: {
    fontFamily: 'Montserrat',
    // margin: 5,
    fontSize: "70%",
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: 30,
    padding: 10,
    "&:hover": {
      background: `rgba(0, 0, 0, 0.5)`,
    },
  },
  rootSearch: {
    padding: 0,
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
    width: "90%",
    backgroundColor: "#F8F9FA",
  },
  appbarDesk: {
    backgroundColor: "#F8F9FA",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    backgroundColor: '#F8F9FA',
    paddingLeft: 30,
    borderRadius: 30,
    border: "1px solid #979797"
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  rootAppbar: {
    flexGrow: 1,
    marginBottom: 70
  },
  appbar: {
    backgroundColor: '#F8F9FA',
    boxShadow: `2 0 4px 0px #000000`,
  },
  iconAppbar: {
    color: '#4B4B4B'
  },
  iconAppbarDrawer: {
    color: 'black'
  },
  menuButtonAppbar: {
    marginRight: theme.spacing(2),
  },
  titleAppbar: {
    flexGrow: 1,
    textAlign: 'center'
  },
  imgAppbar: {
    maxWidth: 200,
    maxHeight: 50,
    marginTop: 5
  },
  rootSearchApp: {
    margin: '0px 6px 0 6px',
    // padding: '0px 20px 0 10px',
    display: 'flex',
    alignItems: 'center',
    width: "95%",
    backgroundColor: '#F8F9FA',
    borderBottom: "1px solid white"
  },
  textApp: {
    marginLeft: theme.spacing(1),
    flex: 1,
    textAlign: 'right',
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: "bold",
  },
  margin: {
    margin: "0 !important",
    padding: "0 !important"
  },
  contentWait: {
    margin: "100px 0px 100px 0",
    width: "100%",
    textAlign: 'center',
  },
  contentWaitImg: {
    width: "10%",
    minWidth: "150px",
    padding: 0,
    margin: 0,
  },

  contentWaitText: {
    fontFamily: 'Poppins',
    fontSize: 14,
    position: 'absolute',
    top: "50%",
    bottom: "50%",
    left: "45%",
    right: "55%",
    color: 'red'
  },
  IconFooter: {
    width: "20%",
    minWidth: "150px",
    maxHeight: 150,
    padding: 0,
    margin: 0,
  },
  btn: {
    background: `#F20746`,
    color: 'white'
  },
  btnFacebook: {
    backgroundColor: `#3b5998`,
    color: 'white',
    margin: 10,
    "&:hover": {
      background: `rgb(241,231,231)`,
      color: 'black',
    },
  },
  btnBack: {
    marginTop: 30,
    marginLeft: 50,
    textAlign: 'left',
    width: 100,
    fontWeight: 'bold',
    fontFamily: 'Poppins',
    color: '#F20746',
  },
  contentTitle: {
    borderTop: "1px solid #DFDFDF",
    margin: "10px 53px 0px 53px",
  },
  btnWhatsapp: {
    backgroundColor: `#00bb2d`,
    color: 'white',
    margin: 10,
    "&:hover": {
      background: `rgb(241,231,231)`,
      color: 'black',
    },
  },
  containerShare: {
    textAlign: 'center',
  },
  containerMedia: {
    textAlign: 'center',
    // background: `#F20746`,
  },
  contenCategory: {
    fontWeight: 'bold',
    fontFamily: 'Poppins',
    color: '#F20746',
    fontSize: 20,
  },
  containerTitleDescription: {
    fontFamily: 'Poppins',
    fontSize: "14px",
    textAlign: "justify",
    color: '#4B4B4B',
    lineHeight: '25px',
  },
  contentHeader: {
    // color: '#F20746',
    fontFamily: 'Poppins',
    padding: 0,
    margin: 0,
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  contentHeaderApp: {
    // color: '#F20746',
    fontFamily: 'Poppins',
    padding: 0,
    margin: 0,
    fontSize: 13,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  headerTitleMenu: {
    // color: '#F20746',
    fontFamily: 'Poppins',
    fontSize: 20,
    padding: 20,
    marginBottom: 10,
    textAlign: 'center',
    borderBottom: "1px solid #EEEEEE",

  },
  contentVideo: {
    width: "100%",
    height: "100%",
    color: 'white',
    maxHeight: "350px"
  },
  btnEmail: {
    zIndex: 1000,
    position: "fixed",
    top: "85%",
    right: 10,
    backgroundColor: '#F20746',
    color: 'white',
  },
  cardTitleModal: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  cardHeaderModal: {
    boxShadow: `-5px -10px 1px #e4e4e4`,
    background: `linear-gradient(90deg, #F20746 0%, #D91448 100%)`
  },
  textModal: {
    textAlign: 'justify',
  },
  contentPublished: {
    fontFamily: 'Poppins',
  },
  containerDetail: {
    padding: "10px 30px 10px 30px",
    // backgroundColor: 'red',
  },
  IconDrawerMenu: {
    width: 200,
    margin: 30
  },
  DrawerMenuAppBar: {
    backgroundColor: '#F8F9FA',
  },
  chipApp: {
    fontFamily: 'Poppins',
    padding: "5px 5px 5px 15px",
    margin: "7px 10px 7px 0px",
    color: "#4B4B4B",
    borderTopRightRadius: "30px",
    borderBottomRightRadius: "30px",
  },

  titleCarrousel: {
    textAling: 'justify',
    color: 'black',
    fontFamily: 'Poppins',
    fontSize: '30px',
    fontWeight: 900,
    letterSpacing: 0,
    lineHeight: '50px',
  },
  title2Carrousel: {
    color: '#F20746',
  },
  subTitleCarrousel: {
    textAling: 'justify',
    color: '#BFBFBF',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '30px',
  },
  cardRootSuscription: {
    backgroundColor: 'transparent',
    border: "1px solid white",
    width: "98%",
    maxWidth: 330,
    minHeight: 350,
    height: 350,
    margin: "10px 0 10px 10px",
    cursor: 'pointer',
  },
  cardRootSuscriptionBorder: {
    background: 'linear-gradient(90deg, #F20746 0%, #D91448 100%)',
    width: "100%",
    height: 10,
  },
  cardRootSuscriptionMensaje: {
    height: '140px',
    width: '267px',
    color: 'black',
    fontFamily: 'Montserrat',
    fontSize: '30px',
    fontWeight: 'bold',
    letterSpacing: 0,
    lineHeight: '35px',
    margin: "0 auto",
    paddingTop: "30px",
  },
  cardRootSuscriptionBtn: {
    margin: "15px 0px 30px 0",
    height: '60px',
    width: '100%',
    color: "white",
    background: 'linear-gradient(90deg, #F20746 0%, #D91448 100%)',
    fontFamily: 'Montserrat',
  },
});

export default appStyle;
